$('.thumbnail .image[data-src]').each((_, $image) => {
  $($image).append('<img class="image-img">')
})
